import {BackSide, BufferGeometry, Face3, Vector2, Vector3} from 'three'
import GenericLoader from 'js/3d/lib/genericLoader'
import geometryHelpers from '../geometry'

// Adapted from THREE example by @aleeper & @mrdoob
/**
 * @class OBJLoader
 *
 * Handles parsing .obj files into threejs 3d objects.
 * This file type is currently unsupported in viewscreen
 *
 */
class OBJLoader extends GenericLoader {
  constructor(...args) {
    super(...args)
    this.parse = this.parse.bind(this)
  }

  side() {
    return BackSide
  }

  parse(data) {
    const geometry = new BufferGeometry()
    const uvcoords = []
    const patternInstruction = /^(f|g|o|vn|vt|v) +(.*[^ ]) *$/

    const instructions = {
      f: line => {
        const f = line.split(' ').map(l => l.split('/'))
        const indices = [
          parseInt(f[0][0]) - 1,
          parseInt(f[1][0]) - 1,
          parseInt(f[2][0]) - 1,
          f[3] ? parseInt(f[3][0]) - 1 : undefined
        ]
        const uvIndices = [
          parseInt(f[0][1]) - 1,
          parseInt(f[1][1]) - 1,
          parseInt(f[2][1]) - 1,
          f[3] ? parseInt(f[3][1]) - 1 : undefined
        ]
        let newNormal = this.calculateNormal(geometry, indices[0], indices[1], indices[2])
        geometry.faces.push(new Face3(indices[0], indices[1], indices[2], newNormal))
        const hasUv = uvIndices[0] && !isNaN(uvIndices[0])
        if (hasUv) {
          geometry.faceVertexUvs[0].push([uvcoords[uvIndices[0]], uvcoords[uvIndices[1]], uvcoords[uvIndices[2]]])
        }
        if (f.length === 4) {
          newNormal = this.calculateNormal(geometry, indices[0], indices[2], indices[3])
          geometry.faces.push(new Face3(indices[2], indices[3], indices[0], newNormal))
          if (hasUv) {
            geometry.faceVertexUvs[0].push([uvcoords[uvIndices[2]], uvcoords[uvIndices[3]], uvcoords[uvIndices[0]]])
          }
        }
      },
      g: () => ({}),
      o: line => {
        geometry.name = line
      },
      vn: () => ({}),
      vt: line => {
        const uv = line.split(' ').map(f => parseFloat(f))
        uvcoords.push(new Vector2(uv[0], uv[1]))
      },
      v: line => {
        const verts = line.split(' ').map(f => parseFloat(f))
        geometry.vertices.push(new Vector3(verts[0], verts[2], verts[1]))
      }
    }

    for (const line of data.split('\n')) {
      let result
      if ((result = line.match(patternInstruction))) {
        const parser = instructions[result[1]]
        if (parser) {
          parser(result[2])
        }
      }
    }

    geometry.computeFaceNormals()
    geometryHelpers.computeFaceCentroids(geometry)
    geometry.computeBoundingBox()
    geometry.computeBoundingSphere()
    return geometry
  }
}

GenericLoader.extensions['obj'] = OBJLoader

export default OBJLoader
